import React, { useEffect, useState } from "react";
import StorageService from "../../services/StorageService";
import AuthService from "../../services/AuthService";
import api from "../../services/AuthApi";
import "../styles/TokenStepper.styles.scss";
import PropTypes from "prop-types";
import { JSEncrypt } from "jsencrypt";
import base64url from "base64url";
import { styled } from "@mui/material/styles";
import { Check, List, Password, Done, Token } from "@mui/icons-material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import {
  Alert,
  AlertTitle,
  Button,
  Box,
  Divider,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Stepper,
  Stack,
  Step,
  StepLabel,
  TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling";
import Alerts from "../../errorHandeling/Alerts";
import SelectUserDropdown from "./SelectUserDropdown";
let base64 = require("base-64")

// Steper Functions
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  width: "80%",
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#784af4",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  }),
}));

//Stepper Icons
function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <List />,
    2: <Password />,
    3: <Token />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function TokenSettings() {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [tokenOption, setTokenOption] = useState("Access Tokens");
  const [tokensAction, setTokensAction] = useState("RTS");
  const [confirmPassword, setConfirmPassword] = useState();
  const accessToken = StorageService.getAccessToken();
  const refreshToken = StorageService.getRefreshToken();
  const username = StorageService.getUsername();
  const [nextButtonDisable, setNextButtonDisable] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isConfirmedError, setIsConfirmedError] = useState(false);
  const [confirmedErrorMessages, setConfirmedErrorMessages] = useState();

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [iserrorShow, setIserrorShow] = useState(false);
  // const [isUnauhtError, setIsUnauhtError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  // Stepper seteps
  const [selectUser, setSelectUser] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState();
  const steps = ["Select Options", "Confirmed Passord", "Finish"];

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  //Next button Enable/Disable Logic
  useEffect(() => {
    if (
      activeStep === 0 ||
      activeStep === 2 ||
      (!selectUser && isDisabled) ||
      (selectUser &&
        isDisabled &&
        selectedUserName !== null &&
        selectedUserName !== undefined &&
        selectedUserName !== "")
    ) {
      setNextButtonDisable(false);
    } else {
      setNextButtonDisable(true);
    }
  }, [isDisabled, selectUser, activeStep, selectedUserName]);

  // Stepper Next button
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === 2 && !selectUser) {
      handleTokenselete();
    }
    if (activeStep === 2 && selectUser) {
      logoutUser();
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setNextButtonDisable(false);
    setIsSubmit(false);
    setIsDisabled(false);
  };

  const handleReset = () => {
    setActiveStep(0);
    setIsDisabled(false);
    setSelectedUserName();
  };

  const encrypt = new JSEncrypt();
  const publicKey = `
    -----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsy+1EQqpdOCQM4OaAflU9rQZGzo8TexVbkez7q67egtwZT5BCG5bClBk95paacF3HgMwh4se6ZhttdkiJfr/gGagOqP2FTZKqEaz7d24FSpYyKUVdgZ7eDNgiBbkWVZi83dGqlMGM2wmES3Q614P3JN+BiZ5srvc4q0BXnw8y40MB10KY0dONVuKrywKEKoHCfjIvKJNH3FyYaCwslQC4m94ErDr5OGbO3qPLiJzw7fRoU3WN05OZvGuYkgS0yN2KUKOp/vAyG6h1Mf+bayILTAGJRxyYdLGvL8Y/90NIFNvXtO4IHfY8HO/bymOic/gPE7XU1lHTK1EvrF55a/E3wIDAQAB
    -----END PUBLIC KEY-----`;
  // Assign encryptor to utilize the public key.
  encrypt.setPublicKey(publicKey);

  // Get Values From Steps
  const handleOptionChange = (event) => {
    const value = event.target.value;
    setTokenOption(value);
    value === "User" ? setSelectUser(true) : setSelectUser(false);
    value === "Tokens" ? setTokensAction("RTS") : setTokensAction("RATS");
  };

  const handleOnChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  // State replace to initial states
  const handleClearData = () => {
    setIsSuccess(false);
    setSuccessMessages([""]);
    setIsSubmit(false);
  };

  let delConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const handleTokenselete = () => {
    const payload = {
      data: {
        revokeAction: tokensAction,
        username: username,
        tokens: [
          {
            accessToken: accessToken,
            refreshToken: refreshToken,
          },
        ],
      },
    };
    api
      .delete("/tokens/revoke", payload, delConfig)
      .then((res) => {
        setErrorMessages([]);
        setIserror(false);
        setErrorMessages([]);
        setIsSuccess(true);
        setSuccessMessages([res.data?.description]);
        setTimeout(() => {
          if (tokensAction === "RTS") {
            AuthService.LogoutWithoutAPI();
          }
          handleClearData();
        }, 5000);
      })
      .catch((error) => {
        setIsSubmit(false);
        setIsSuccess(false);
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        );
        setTimeout(() => {
          handleClearData();
        }, 5000);
      });
  };

  const handleSelectChange = (e) => {
    setSelectedUserName(e.value);
  };

  const logoutUser = () => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          base64.encode(
            process.env.REACT_APP_AUTH_USERNAME +
              ":" +
              process.env.REACT_APP_AUTH_PASSWORD
          ),
      },
    }
    const payload = {
      data: { revokeAction: "RATU", username: selectedUserName },
    };
    api
      .delete("/tokens/revoke", payload, config)
      .then((res) => {
        setErrorMessages([]);
        setIserror(false);
        setErrorMessages([]);
        setIsSuccess(true);
        setSuccessMessages([res.data?.description]);
        setTimeout(() => {
          if (tokensAction === "RTS") {
            AuthService.LogoutWithoutAPI();
          }
          handleClearData();
        }, 5000);
      })
      .catch((error) => {
        setIsSubmit(false);
        setIsSuccess(false);
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        );
        setTimeout(() => {
          handleClearData();
        }, 5000);
      });
  };

  const handleConfirmPassword = (event) => {
    event.preventDefault();
    // Perform our encryption based on our public key - only private key can read it!
    const encryptedInputPassword = encrypt.encrypt(
      confirmPassword ? confirmPassword : ""
    );

    //Converting the encrypted password to url friendly base64URL encoded
    const urlEncodedInputPassword = base64url.toBase64(encryptedInputPassword);
    setIsSubmit(true);
    let postConfig = {
      headers: {
        "Content-Type": "application/json",
        password: urlEncodedInputPassword,
      },
    };

    api
      .get("/users/confirm/" + username, postConfig)
      .then((res) => {
        if (res.data === false) {
          setIsConfirmedError(true);
          setConfirmedErrorMessages("Password Incorrect");
        }
        if (res.data === true) {
          setIsConfirmedError(false);
          setConfirmedErrorMessages();
          setIsDisabled(true);
        }
        setTimeout(() => {
          handleClearData();
        }, 3000);
      })
      .catch((error) => {
        setConfirmedErrorMessages(error.response.data.description);
        setIsConfirmedError(true);
        setIsSubmit(false);
      });
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            <div>
              <Alerts
                iserror={iserror}
                errorMessages={errorMessages}
                isSuccess={isSuccess}
                successMessages={successMessages}
                iserrorShow={iserrorShow}
              />
            </div>
            <br />
            All steps completed - you&apos;re finished All steps completed -
            you're finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </React.Fragment>
      ) : (
        <Paper elevation={8} className="paperGap">
          <React.Fragment>
            <Typography className="ationBody">
              <br /> <br />
              {(activeStep === 0 && (
                <>
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    <strong>Please Select an Option to move forward</strong> —
                    <ul>
                      <li>
                        Selecting Option 1 will clear all Access tokens and
                        Refresh Tokens
                      </li>
                      <li>Selecting Option 2 will clear only Access Tokens</li>
                    </ul>
                  </Alert>
                  <div className="formGroup">
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={tokenOption}
                        onChange={handleOptionChange}>
                        <FormControlLabel
                          value="Access Tokens"
                          control={<Radio />}
                          label="Clear all access tokens"
                        />
                        <FormControlLabel
                          value="User"
                          control={<Radio />}
                          label="Clear selected users access tokens"
                        />
                        <FormControlLabel
                          value="Tokens"
                          control={<Radio />}
                          label="Clear all tokens"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </>
              )) ||
                (activeStep === 1 && (
                  <>
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      <strong>Please Reenter Password to Confirm</strong> —
                    </Alert>
                    <br />
                    <form onSubmit={handleConfirmPassword} width="100%">
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ position: "relative" }}>
                        <Item elevation={0}>
                          <TextField
                            fullWidth
                            autoFocus
                            color="secondary"
                            variant="outlined"
                            name="confirmedPassword"
                            label="Confirmed Password"
                            type="password"
                            required
                            error={isConfirmedError}
                            helperText={confirmedErrorMessages}
                            onChange={handleOnChange}
                          />
                        </Item>
                        <LoadingButton
                          sx={{ position: "absolute", top: 10, right: 0 }}
                          className="buttonHeight"
                          loading={isSubmit}
                          loadingPosition="start"
                          disabled={isDisabled}
                          startIcon={isDisabled ? <Done /> : <Password />}
                          variant="contained"
                          color="success"
                          type="submit">
                          {isDisabled ? "Confirmed" : "Confirmation"}
                        </LoadingButton>
                      </Stack>
                    </form>
                    <br />
                    {isDisabled && selectUser && (
                      <SelectUserDropdown onChange={handleSelectChange} />
                    )}
                  </>
                )) ||
                (activeStep === 2 && (
                  <Alert severity="warning">
                    <AlertTitle>Warning</AlertTitle>
                    <strong>Are You Sure ?</strong> —
                    <ul>
                      <li>
                        When You Click Finish, All {tokenOption} Will Be Cleared
                      </li>
                    </ul>
                  </Alert>
                ))}
            </Typography>
            <Divider />
            <Box className="butttonPlace" sx={{ mt: "50px" }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                onClick={handleNext}
                disabled={nextButtonDisable}
                sx={{ alignItems: "flex-end" }}>
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>
            </Box>
          </React.Fragment>
        </Paper>
      )}
    </Stack>
  );
}
